import React, { useEffect, useState } from "react";
import { Download, Share, PlusSquare, MoreVertical } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export function InstallAppButton() {
  const [prompt, setPrompt] = useState(window.__rawajInstall || null);
  const [installed, setInstalled] = useState(isStandalone());
  const [help, setHelp] = useState(false);

  useEffect(() => {
    const onReady = () => setPrompt(window.__rawajInstall);
    const onDone = () => setInstalled(true);
    window.addEventListener("rawaj-install-ready", onReady);
    window.addEventListener("appinstalled", onDone);
    return () => { window.removeEventListener("rawaj-install-ready", onReady); window.removeEventListener("appinstalled", onDone); };
  }, []);

  if (installed) return null;

  const install = async () => {
    if (!prompt) return setHelp(true);
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") setInstalled(true);
    window.__rawajInstall = null; setPrompt(null);
  };

  return (
    <>
      <Button onClick={install} variant="outline" className="rounded-full border-primary/40 bg-secondary/80 text-primary hover:border-primary hover:bg-secondary gap-1.5 h-9 px-3" data-testid="install-app-btn" title="ثبّت تطبيق رواج الذكية">
        <Download className="w-4 h-4" /> <span className="hidden sm:inline">{localStorage.getItem("rawaj_lang") === "en" ? "Install app" : "تثبيت التطبيق"}</span>
      </Button>
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent className="bg-popover border-border max-w-sm" dir="rtl" data-testid="install-help-dialog">
          <DialogHeader>
            <DialogTitle className="text-start flex items-center gap-2"><img src="/icon-192.png" alt="" className="w-8 h-8 rounded-lg" /> ثبّت رواج الذكية على جهازك</DialogTitle>
            <DialogDescription className="text-start">افتح رواج الذكية كتطبيق مباشرة من شاشتك الرئيسية</DialogDescription>
          </DialogHeader>
          {isIOS() ? (
            <ol className="space-y-3 text-sm" data-testid="install-ios-steps">
              <li className="flex items-center gap-2"><Share className="w-4 h-4 text-primary shrink-0" /> 1. اضغط زر المشاركة في متصفح Safari</li>
              <li className="flex items-center gap-2"><PlusSquare className="w-4 h-4 text-primary shrink-0" /> 2. اختر «إضافة إلى الشاشة الرئيسية»</li>
              <li className="flex items-center gap-2"><Download className="w-4 h-4 text-primary shrink-0" /> 3. اضغط «إضافة» وستظهر أيقونة رواج الذكية</li>
            </ol>
          ) : (
            <ol className="space-y-3 text-sm" data-testid="install-other-steps">
              <li className="flex items-center gap-2"><MoreVertical className="w-4 h-4 text-primary shrink-0" /> 1. افتح قائمة المتصفح (⋮) أعلى الشاشة</li>
              <li className="flex items-center gap-2"><Download className="w-4 h-4 text-primary shrink-0" /> 2. اختر «تثبيت التطبيق» أو «إضافة إلى الشاشة الرئيسية»</li>
            </ol>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
